class Drawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelector('[id*=-Overlay]')?.addEventListener('click', this.close.bind(this));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      document.querySelector('mobile-menu').mobilemenuHide();
      document.body.classList.add('drawer--isActive');

      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : this.firstElementChild;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');

    setTimeout(() => document.body.classList.remove('drawer--isActive'), 300);

    document.body.dispatchEvent(new CustomEvent("drawerClosed"));
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('drawer-component', Drawer);

class DrawerButton extends Drawer {
  drawerTag = null;
  drawer = null;
  drawerEnergyRating = null;

  connectedCallback() {
    this.drawerTag = this.dataset.drawerTag;
    this.drawerEnergyRating = this.dataset.energyRating;

    if (this.classList.contains('hotspot')) {
      this.addEventListener('mouseenter', this.handleHotspotHover.bind(this));
    }

    if (!this.drawerTag) return;
    this.drawer = document.querySelector(`#${this.drawerTag}`);

    if (!this.drawer) return;
    this.addEventListener('click', (event) => this.handleClick(event));
  }

  handleClick(event) {
    let action = (this.dataset.action) ? this.dataset.action : 'open';

    action === 'open' ? this.drawer.open(this) : this.drawer.close();
  }

  handleHotspotHover() {
    const overlay = this.querySelector('.hotspot__overlay');
    if (!overlay) return;

    const overlayHeight = overlay.offsetHeight;
    const beforeStyles = window.getComputedStyle(overlay, '::before');
    let extraSpace = parseFloat(beforeStyles.height);
    if (isNaN(extraSpace)) extraSpace = 20;

    const totalRequiredHeight = overlayHeight + extraSpace;
    const hotspotRect = this.getBoundingClientRect();
    const spaceBelow = window.innerHeight - hotspotRect.bottom;
    const section = this.closest('.shopify-section') || this.closest('section') || this.parentNode;
    let spaceBelowSection = Infinity;
    
    if (section) {
      const sectionRect = section.getBoundingClientRect();
      spaceBelowSection = sectionRect.bottom - hotspotRect.bottom;
    }

    if (spaceBelow < totalRequiredHeight || spaceBelowSection < totalRequiredHeight) {
      this.classList.add('hotspot--flip');
    } else {
      this.classList.remove('hotspot--flip');
    }
  }
}

customElements.define('drawer-button', DrawerButton);
